export default "<span><ng-content></ng-content></span>\n"